import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';
import { PRICE } from '../data/content';
import { SecurePaymentNote } from './SecurePaymentNote';

/** The single checkout the offer button leads to. */
export const CHECKOUT_URL = 'https://lashandbrowit.impultienda.ar/checkout';
export const CURRENCY_NOTE = 'Pagamento sicuro · Elaborato nella tua valuta locale';

/** Anchor of the offer block — the only button that opens the checkout. */
export const OFFER_ANCHOR = '#offer-cta';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the checkout; 'offer' scrolls to the offer block. */
  action?: 'checkout' | 'offer';
  className?: string;
}
export function CtaButton({
  label,
  action = 'offer',
  className = ''
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-[14px] bg-brand-cta px-5 py-[18px] font-body text-[13px] font-bold uppercase tracking-[0.04em] text-brand-cta-text shadow-[0_5px_0_0_#3E5230,0_18px_34px_-14px_rgba(76,99,57,0.7)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-brand-cta-dark active:translate-y-[3px] active:shadow-[0_2px_0_0_#3E5230] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2 focus-visible:ring-offset-brand-ivory sm:px-8 sm:text-[15px] sm:tracking-[0.06em] ${className}`} data-id="element-1" data-mp="19aa1xho41ys1">
      <span data-id="element-2" data-mp="3sviy9p6hubo4">{label}</span>
      <span aria-hidden="true" className="hidden text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1 sm:inline" data-id="element-3" data-mp="1j7t51sm1gf1">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  /** The offer block: shows the price and is the only one that opens the checkout. */
  showPrice?: boolean;
  tone?: 'light' | 'dark';
  className?: string;
}
export function CtaBlock({
  label,
  showPrice = false,
  tone = 'light',
  className = ''
}: CtaBlockProps) {
  const muted = tone === 'dark' ? 'text-brand-ivory/65' : 'text-brand-charcoal/55';
  return <div id={showPrice ? 'offer-cta' : undefined} className={`flex scroll-mt-24 flex-col items-center text-center ${className}`} data-id="element-4" data-mp="ie5rkd51m1v">
      {showPrice ? <>
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-5" data-mp="9iaqjaweq0rn">
            Pagamento unico
          </p>
          <p className="mt-2 font-body text-[3rem] font-bold leading-none tracking-[-0.01em] text-brand-charcoal" data-id="element-6" data-mp="4iy5mvp3j3rp">
            {PRICE}
          </p>
        </> : <p className={`font-body text-[11px] uppercase tracking-[0.14em] ${muted}`} data-id="element-7" data-mp="ehdwcxk7ob0o">{CURRENCY_NOTE}</p>}
      <CtaButton label={label} action={showPrice ? 'checkout' : 'offer'} className="mt-4 w-full sm:w-auto sm:min-w-[420px]" data-id="element-8" data-mp="2l94wu56lg0dv" />
      {showPrice && <SecurePaymentNote className="mt-5" data-id="element-9" data-mp="vr83yd4hbc84" />}
    </div>;
}